module.exports = __webpack_public_path__ + "img/night.fbc61806.jpg";